// extracted by mini-css-extract-plugin
module.exports = {"form":"styles_form__3O18o","row":"styles_row__3YIqT"};